import React, { Component } from 'react';
import PropTypes from 'prop-types';
import Button from 'components/button/ActionButton';
import { DownloadIcon } from 'assets/materialIcons/materialIcons';
import theme from 'theme/theme';
import { connect } from 'react-redux';
import { showNotification } from 'store/actions/uiActions';

class DownloadPDF extends Component {
    constructor(props) {
        super(props);

        this.state = {
            isLoading: false,
        };
    }

    downloadPDF = () => {
        const { downloadFailureAction, fileName, id, request } = this.props;

        this.setState({
            isLoading: true,
        });

        request(id, fileName).then(() => {
            this.setState({
                isLoading: false,
            });
        }, (error) => {
            downloadFailureAction(error);

            this.setState({
                isLoading: false,
            });
        });
    }

    render() {
        const { id, style, title } = this.props;
        const { isLoading } = this.state;

        if (!id) {
            return null;
        }

        return (
            <Button
                disabled={ isLoading }
                icon={ <DownloadIcon color={ theme.palette.doveGray } /> }
                onClick={ this.downloadPDF }
                style={ style }
                title={ title }
            />
        );
    }
}

DownloadPDF.propTypes = {
    downloadFailureAction: PropTypes.func.isRequired,
    id: PropTypes.number.isRequired,
    fileName: PropTypes.string,
    request: PropTypes.func.isRequired,
    style: PropTypes.object,
    title: PropTypes.string.isRequired,
};

const mapDispatchToProps = (dispatch, props) => {
    const {
        failureAction,
    } = props;

    return {
        downloadFailureAction: (error) => {
            if (failureAction) {
                dispatch(failureAction(error));
            } else {
                dispatch(showNotification(error.response.message, 'warning'));
            }
        },
    };
};

export default connect(null, mapDispatchToProps)(DownloadPDF);



// WEBPACK FOOTER //
// ./src/components/button/DownloadPDF.js